import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type TradeIconProps = CommonSvgProps

const TradeIcon: React.FC<TradeIconProps> = React.forwardRef<SVGSVGElement, TradeIconProps>(
  (props, ref) => (
    <Svg viewBox="0 0 49 33" {...props} ref={ref} color="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0732 30.2733C10.0732 29.9428 10.3411 29.6749 10.6716 29.6749H48.3622C48.6926 29.6749 48.9605 29.9428 48.9605 30.2733V30.7827C48.9605 30.9279 48.9077 31.0681 48.812 31.1773L47.6059 32.5523C47.4923 32.6819 47.3284 32.7561 47.1561 32.7561H11.8777C11.7054 32.7561 11.5415 32.6819 11.4279 32.5523L10.2218 31.1773C10.126 31.0681 10.0732 30.9279 10.0732 30.7827V30.2733ZM47.4884 30.8716H11.5454L12.1488 31.5595H46.885L47.4884 30.8716Z"
        fill="#51565C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5234 9.16645C12.5234 8.836 12.7913 8.56812 13.1218 8.56812H45.9126C46.2431 8.56812 46.5109 8.836 46.5109 9.16645V30.2732C46.5109 30.6036 46.2431 30.8715 45.9126 30.8715H13.1218C12.7913 30.8715 12.5234 30.6036 12.5234 30.2732V9.16645ZM13.7201 9.76479V29.6749H45.3143V9.76479H13.7201Z"
        fill="#51565C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.683594 7.05858C0.683594 6.86975 0.836671 6.71667 1.0255 6.71667H4.89055C5.07938 6.71667 5.23246 6.86975 5.23246 7.05858V10.9236C5.23246 11.1125 5.07938 11.2655 4.89055 11.2655H1.0255C0.836671 11.2655 0.683594 11.1125 0.683594 10.9236V7.05858Z"
        fill="#53A2D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.02572 6.03284H4.89077C5.45727 6.03284 5.9165 6.49207 5.9165 7.05856V10.9236C5.9165 11.4901 5.45726 11.9493 4.89077 11.9493H1.02572C0.459231 11.9493 0 11.4901 0 10.9236V7.05856C0 6.49207 0.459233 6.03284 1.02572 6.03284ZM1.02572 6.71665C0.836893 6.71665 0.683815 6.86973 0.683815 7.05856V10.9236C0.683815 11.1124 0.836892 11.2655 1.02572 11.2655H4.89077C5.0796 11.2655 5.23268 11.1124 5.23268 10.9236V7.05856C5.23268 6.86973 5.07961 6.71665 4.89077 6.71665H1.02572Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.77197 1.78185C5.77197 1.59302 5.92505 1.43994 6.11388 1.43994H9.97893C10.1678 1.43994 10.3208 1.59302 10.3208 1.78185V5.6469C10.3208 5.83573 10.1678 5.98881 9.97893 5.98881H6.11388C5.92505 5.98881 5.77197 5.83573 5.77197 5.6469V1.78185Z"
        fill="#53A2D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.1141 0.756104H9.97915C10.5456 0.756104 11.0049 1.21534 11.0049 1.78183V5.64688C11.0049 6.21337 10.5456 6.6726 9.97915 6.6726H6.1141C5.54761 6.6726 5.08838 6.21337 5.08838 5.64688V1.78183C5.08838 1.21533 5.54761 0.756104 6.1141 0.756104ZM6.1141 1.43992C5.92527 1.43992 5.77219 1.593 5.77219 1.78183V5.64688C5.77219 5.83571 5.92527 5.98879 6.1141 5.98879H9.97915C10.168 5.98879 10.3211 5.83571 10.3211 5.64688V1.78183C10.3211 1.593 10.168 1.43992 9.97915 1.43992H6.1141Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.77197 12.5237C5.77197 12.3348 5.92505 12.1818 6.11388 12.1818H9.97893C10.1678 12.1818 10.3208 12.3348 10.3208 12.5237V16.3887C10.3208 16.5776 10.1678 16.7306 9.97893 16.7306H6.11388C5.92505 16.7306 5.77197 16.5776 5.77197 16.3887V12.5237Z"
        fill="#7BB835"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.1141 11.4979H9.97915C10.5456 11.4979 11.0049 11.9572 11.0049 12.5236V16.3887C11.0049 16.9552 10.5456 17.4144 9.97915 17.4144H6.1141C5.54761 17.4144 5.08838 16.9552 5.08838 16.3887V12.5236C5.08838 11.9572 5.54761 11.4979 6.1141 11.4979ZM6.1141 12.1817C5.92527 12.1817 5.77219 12.3348 5.77219 12.5236V16.3887C5.77219 16.5775 5.92527 16.7306 6.1141 16.7306H9.97915C10.168 16.7306 10.3211 16.5775 10.3211 16.3887V12.5236C10.3211 12.3348 10.168 12.1817 9.97915 12.1817H6.1141Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8604 7.05858C10.8604 6.86975 11.0134 6.71667 11.2023 6.71667H15.0673C15.2561 6.71667 15.4092 6.86975 15.4092 7.05858V10.9236C15.4092 11.1125 15.2561 11.2655 15.0673 11.2655H11.2023C11.0134 11.2655 10.8604 11.1125 10.8604 10.9236V7.05858Z"
        fill="#7BB835"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.202 6.03284H15.067C15.6335 6.03284 16.0928 6.49207 16.0928 7.05856V10.9236C16.0928 11.4901 15.6335 11.9493 15.067 11.9493H11.202C10.6355 11.9493 10.1763 11.4901 10.1763 10.9236V7.05856C10.1763 6.49207 10.6355 6.03284 11.202 6.03284ZM11.202 6.71665C11.0132 6.71665 10.8601 6.86973 10.8601 7.05856V10.9236C10.8601 11.1124 11.0132 11.2655 11.202 11.2655H15.067C15.2559 11.2655 15.409 11.1124 15.409 10.9236V7.05856C15.409 6.86973 15.2559 6.71665 15.067 6.71665H11.202Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9482 12.5237C15.9482 12.3348 16.1013 12.1818 16.2901 12.1818H20.1552C20.344 12.1818 20.4971 12.3348 20.4971 12.5237V16.3887C20.4971 16.5776 20.344 16.7306 20.1552 16.7306H16.2901C16.1013 16.7306 15.9482 16.5776 15.9482 16.3887V12.5237Z"
        fill="#15539F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2904 11.4979H20.1554C20.7219 11.4979 21.1811 11.9572 21.1811 12.5236V16.3887C21.1811 16.9552 20.7219 17.4144 20.1554 17.4144H16.2904C15.7239 17.4144 15.2646 16.9552 15.2646 16.3887V12.5236C15.2646 11.9572 15.7239 11.4979 16.2904 11.4979ZM16.2904 12.1817C16.1015 12.1817 15.9485 12.3348 15.9485 12.5236V16.3887C15.9485 16.5775 16.1015 16.7306 16.2904 16.7306H20.1554C20.3443 16.7306 20.4973 16.5775 20.4973 16.3887V12.5236C20.4973 12.3348 20.3443 12.1817 20.1554 12.1817H16.2904Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8604 17.8003C10.8604 17.6115 11.0134 17.4584 11.2023 17.4584H15.0673C15.2561 17.4584 15.4092 17.6115 15.4092 17.8003V21.6653C15.4092 21.8542 15.2561 22.0072 15.0673 22.0072H11.2023C11.0134 22.0072 10.8604 21.8542 10.8604 21.6653V17.8003Z"
        fill="#15539F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.202 16.7745H15.067C15.6335 16.7745 16.0928 17.2338 16.0928 17.8003V21.6653C16.0928 22.2318 15.6335 22.691 15.067 22.691H11.202C10.6355 22.691 10.1763 22.2318 10.1763 21.6653V17.8003C10.1763 17.2338 10.6355 16.7745 11.202 16.7745ZM11.202 17.4584C11.0132 17.4584 10.8601 17.6114 10.8601 17.8003V21.6653C10.8601 21.8541 11.0132 22.0072 11.202 22.0072H15.067C15.2559 22.0072 15.409 21.8541 15.409 21.6653V17.8003C15.409 17.6114 15.2559 17.4584 15.067 17.4584H11.202Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.4139 17.8353L22.8395 18.3635L24.6425 20.4106H18.3984V21.3119H24.6237L22.8395 23.3376L23.4139 23.8658L25.8376 21.114C25.9696 20.9642 25.9696 20.737 25.8376 20.5871L23.4139 17.8353Z"
        fill="#51565C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.2295 17.4827C30.2295 17.1995 30.4591 16.9698 30.7424 16.9698H39.5841C39.8673 16.9698 40.0969 17.1995 40.0969 17.4827C40.0969 17.766 39.8673 17.9956 39.5841 17.9956H30.7424C30.4591 17.9956 30.2295 17.766 30.2295 17.4827Z"
        fill="#51565C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.2295 20.6863C30.2295 20.4031 30.4591 20.1735 30.7424 20.1735H39.5841C39.8673 20.1735 40.0969 20.4031 40.0969 20.6863C40.0969 20.9696 39.8673 21.1992 39.5841 21.1992H30.7424C30.4591 21.1992 30.2295 20.9696 30.2295 20.6863Z"
        fill="#51565C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.2295 23.8901C30.2295 23.6068 30.4591 23.3772 30.7424 23.3772H39.5841C39.8673 23.3772 40.0969 23.6068 40.0969 23.8901C40.0969 24.1733 39.8673 24.4029 39.5841 24.4029H30.7424C30.4591 24.4029 30.2295 24.1733 30.2295 23.8901Z"
        fill="#51565C"
      />
    </Svg>
  )
)

TradeIcon.propTypes = commonPropTypes
TradeIcon.defaultProps = commonDefaultProps

export default TradeIcon
